export default {
  ThousandUnit: 'Nghìn đồng',
  OneUnit: 'Đồng',
  GroupLabelUnit: 'Đơn vị tính',
  CheckFormula: 'Kiểm tra công thức',
  TitleOne: 'CÂN ĐỐI NGÂN SÁCH XÃ 06 THÁNG ĐẦU NĂM',
  TitleTwo: 'CÂN ĐỐI NGÂN SÁCH XÃ 06 THÁNG CUỐI NĂM',
  TitleThere: 'CÂN ĐỐI NGÂN SÁCH XÃ QUÝ I NĂM',
  TitleFour: 'CÂN ĐỐI NGÂN SÁCH XÃ QUÝ II NĂM',
  TitleFive: 'CÂN ĐỐI NGÂN SÁCH XÃ QUÝ III NĂM',
  TitleSix: 'CÂN ĐỐI NGÂN SÁCH XÃ QUÝ IV NĂM',
  TitleSeven: 'CÂN ĐỐI NGÂN SÁCH XÃ NĂM',
};
